import { AxiosInstance } from 'axios';
import { simulate } from './utils';
import { TipRequest } from 'referral-types';

export const baseEndpoint = 'tip';

export class TipApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getIntent(formValues: TipRequest): Promise<string> {
    await simulate();
    const response = await this.apiInstance.post(`/intent`, formValues);

    return response.data; 
  }
}
